import { Progress } from 'antd';
import { NotificationExtended } from 'src/api/generated';
import { useGetJob } from 'src/hooks/api/useJobsEndpoint';

interface ImportProgressProps {
  item: NotificationExtended;
}

const ImportProgress = (props: ImportProgressProps) => {
  const { item } = props;

  const { data: job } = useGetJob(item.id);
  const processed = (job?.successItems ?? 0) + (job?.failedItems ?? 0);
  const totalRows = job?.totalItems ?? 0;

  const getPercentage = () => {
    if (totalRows === 0) return 0;
    return Math.round((processed / totalRows) * 100);
  };

  const getStatus = () => {
    if (processed < totalRows) return 'active';
    if (job?.failedItems && job?.failedItems > 0) return 'exception';
    if (job?.successItems && job?.successItems > 0) return 'success';
    return;
  };

  return <Progress percent={getPercentage()} size="small" showInfo={false} status={getStatus()} />;
};

export default ImportProgress;
